var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.753 1h-16.82c-2.1722 0-3.9331 1.7609-3.9331 3.9331v16.82c0 2.1722 1.7609 3.9331 3.9331 3.9331h16.82c2.1722 0 3.9331-1.7609 3.9331-3.9331v-16.82c0-2.1722-1.7609-3.9331-3.9331-3.9331z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.8555 .38534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.0205 7.4663h14.356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.0205 18.449h14.356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.0205 12.958h14.356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.0205 7.804v10.645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.376 7.804v10.645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.806 7.804v10.645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.591 7.804v10.645"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeTable);
export default __webpack_public_path__ + "static/media/icon_type_table.9f37ee82854d38852e35bd6627c8ee27.svg";
export { ForwardRef as ReactComponent };